<router-outlet></router-outlet>
<div style="position: relative; display: flex; justify-content: center; align-items: center; height: 100%; overflow: hidden;">
  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.7)"
    size="small"
    [fullScreen]="true"
    type="line-scale"
    color="white"
    template="
      <div style='position: relative;'>
        <img src='../assets/img/loader/loader.png' style='width: 70px; height: 70px; filter: invert(10); border: 5px solid white; border-radius: 50%; padding: 10px;' />
        <div style='position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: 5px solid transparent; border-top: 5px solid white; border-radius: 50%; animation: spin 1s linear infinite;'></div>
      </div>
    "
  >
  </ngx-spinner>
</div>
<style>
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
